import React, {
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  MixedGridGroup,
  QuantaFormik,
  QuantaForm,
  useResponsiveParams,
  useQuantaFormikContext,
  Text,
} from 'quanta-ui';
import moment from 'moment';
// import {
//   init_state_quote,
//   updateFireQuote,
// } from 'qu';
import { init_state_quote,updateFireQuote } from 'quanta-flows/modules/quote/fire/state';
import { useQuery } from '@apollo/client';
import {
  CHARACTER_LIMIT_LIST,
  CUSTOMER_DROPDOWN_QUERIES,
  GET_FIRE_POLICY_VAR_DETAILS,
  SAVE_QUOTE_FIRE,
  Geographical_Area_list,
  COVER_FIRESA,
  GET_SELECTED_INTERMEDIARY,
  COST_OF_CONSTRUCTION
} from '../../queries';
// import Loading from '../../../../../../lib/layout/loading';
import { Loading } from 'quanta-flows/modules/layout';
// import Error from '../../../../../../lib/layout/error';
//import { Error } from 'quanta-flows/modules/layout';
import CustomerDetails from './customer-details';
import PreviousClaimDetails from './previous-claim-details';
import PolicyDetails from './policy-details';
// import { ConfigContext } from '../../../../../../lib/config/ConfigProvider';
import { QuantaConfigContext } from 'quanta-flows';
// import useFetchQuery from '../../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
// import useMutationQuery from '../../../../../../lib/graphql/useMutationQuery';
import { useMutationQuery } from 'quanta-flows';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export default function Customer({
  productCode,
  setProceedToRiskLocationPage,
  lobCode,
  productName,
  lobName,
  quoteNumber,
  setParentAlerts,
  setParentLoading,
  setCustomLoadingMessage,
  renderExpandedCards,
  renderExpandedCardsFloater,
  role,
  ...props
}) {
  const fetchQuery = useFetchQuery();
  const mutateQuery = useMutationQuery();

  let repeat_for_mobile = 1,
    repeat_for_desktop = 3;

  const { branding } = useContext(QuantaConfigContext);

  let repeat = useResponsiveParams({
    for_mobile: repeat_for_mobile,
    for_desktop: repeat_for_desktop,
  });

  const [fireQuote, setFireQuote] = useState(null);
  const [isQuoteReadOnly, setIsQuoteReadOnly] = useState(false);
  const [selectedIntermediary, setSelectedIntermediary] =
    useState(null);
  const [loadingFireQuote, setLoadingFireQuote] = useState(false);
  const [errorFireQuote, setErrorFireQuote] = useState(null);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setLoadingFireQuote(true);
      fetchQuery({
        query: GET_FIRE_POLICY_VAR_DETAILS,
      })
        ?.then((response) => {
          if (isMounted) {
            setLoadingFireQuote(false);
            setErrorFireQuote(null);
            setFireQuote(response?.data?.fireQuote);
            setIsQuoteReadOnly(
              [
                'quote saved',
                'underwriter approved',
                'underwriter rejected',
                'converted to proposal',
              ]?.includes(
                response?.data?.fireQuote?.status
                  ?.toString()
                  ?.toLowerCase(),
              ) ||
                (role?.toString()?.toLowerCase() !== 'underwriter' &&
                  response?.data?.fireQuote?.status
                    ?.toString()
                    ?.toLowerCase() === 'pending uw approval'),
            );
            setSelectedIntermediary(
              response?.data?.selectedIntermediary,
            );
          }
        })
        ?.catch((error) => {
          if (isMounted) {
            setLoadingFireQuote(false);
            setErrorFireQuote(error?.message);
          }
        });
    }
    return () => {
      isMounted = false;
    };
  }, []);

  const {
    loading: loadingCustomerDropdownData,
    error: errorCustomerDropdownData,
    data: customerDropdownData,
  } = useQuery(CUSTOMER_DROPDOWN_QUERIES, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode,
      domainCode: 'Policy Start Date',
    },
  });
  const {
    loading: loadingGeographicalDropDownData,
    error: errorGeographicalDropDownData,
    data: GeographicalDropDownData,
  } = useQuery(Geographical_Area_list, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode,
      // domainCode: 'Policy Start Date',
    },
  });
 //const {PRD_geographicalArea,} = GeographicalDropDownData;
  const {
    loading: loadingCharacterLimit,
    error: errorCharacteLimit,
    data: dataCharacterLimit,
  } = useQuery(CHARACTER_LIMIT_LIST, {
    fetchPolicy: 'cache-first',
  });
  const { loading:loadingintermediary, 
    error:errorintermediary, data:dataintermediary 
  } = useQuery(
    GET_SELECTED_INTERMEDIARY,
  );
  const {
    loading: loadingCostOfConstruction,
    error: errorCostOfConstruction,
    data: dataCostOfConstruction,
  } = useQuery(COST_OF_CONSTRUCTION, {
    fetchPolicy: 'cache-first',
    variables: {
      input:
      {
        productCode:'1132',
        pincode: '835205'
      }
    },
  });
  // const { PRD_costOfConstruction } =dataCostOfConstruction; 
   if (
    loadingCharacterLimit ||
    loadingCustomerDropdownData ||
    loadingFireQuote ||
    loadingGeographicalDropDownData ||
    loadingintermediary ||
    loadingCostOfConstruction
  ) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }

  if (
    errorCharacteLimit ||
    errorCustomerDropdownData ||
    errorFireQuote ||
    errorGeographicalDropDownData ||
    errorintermediary ||
    errorCostOfConstruction
  ) {
    return (
      <Error
        error={
          errorCharacteLimit ||
          errorCustomerDropdownData ||
          errorFireQuote ||
          errorGeographicalDropDownData ||
          errorintermediary
        }
      />
    );
  }

  const {
    PRD_CustomerTypeList,
    PRD_policyPeriod,
    PRD_basisOfValuation,
    PRD_typeOfPolicy,
    dayRange,
    PRD_claimsInPreviousYear,
    PRD_BusinessSumInsured,
  } = customerDropdownData;
  const {
    PRD_geographicalArea,
    //PRD_costOfConstruction,
  } = GeographicalDropDownData;

  const validate = (values) => {
    if (isQuoteReadOnly) {
      return {};
    }
    let errors = {};
    errors.customerDetails = {};
    errors.previousClaimExperienceDetails = {};
    errors.policyTypeDetails = {};
    errors.riskLocations = {};
    errors.riskLocations.addressDetails= {};
    const firstNameValue =
      dataCharacterLimit?.characterLimitList?.find(
        (characterLimit) =>
          characterLimit.code?.toLowerCase() === 'first name',
      );
    const middleNameValue =
      dataCharacterLimit?.characterLimitList?.find(
        (characterLimit) =>
          characterLimit?.code?.toLowerCase() === 'middle name',
      );
    const lastNameValue =
      dataCharacterLimit?.characterLimitList?.find(
        (characterLimit) =>
          characterLimit?.code?.toLowerCase() === 'last name',
      );
    const orgNameValue = dataCharacterLimit?.characterLimitList?.find(
      (characterLimit) =>
        characterLimit?.code?.toLowerCase() === 'org name',
    );
    if (!values?.productKg) {
      errors.productKg = '* Please select Product Name';
    }
    if(!values?.riskLocations?.addressDetails?.district)
    { 
      errors.riskLocations.addressDetails.district = '* Required'
    }
    if(!values?.riskLocations?.addressDetails?.pincode)
    { 
      errors.riskLocations.addressDetails.pincode = '* Required'
    }
    if(!values?.riskLocations?.addressDetails?.state)
    {
      errors.riskLocations.addressDetails.state = '* Required'
    }
    if (
      values?.customerDetails?.customerType?.code &&
      PRD_CustomerTypeList?.find(
        (type) =>
          type?.code?.toString()?.toLowerCase() ===
          values?.customerDetails?.customerType?.code
            ?.toString()
            ?.toLowerCase(),
      )
        ?.value?.toString()
        ?.toLowerCase() === 'dwelling'
    ) {
      if (!values?.productKg) {
         errors.customerDetails.productKg = '* Please select Product Name';
      }
      if (!values?.customerDetails?.firstName) {
        errors.customerDetails.firstName = '* Required';
      }
      if (
        values?.customerDetails?.firstName &&
        !values?.customerDetails?.firstName.match(/^[a-zA-Z ]*$/)
      ) {
        errors.customerDetails.firstName =
          '* First name can be alphabets only';
      }
      if (
        values?.customerDetails?.firstName &&
        values?.customerDetails?.firstName?.length >
          firstNameValue?.value
      ) {
        errors.customerDetails.firstName = `* First Name cannot be greater than ${firstNameValue?.value} characters`;
      }
      if (
        values?.customerDetails?.middleName &&
        !values?.customerDetails?.middleName.match(/^[a-zA-Z ]*$/)
      ) {
        errors.customerDetails.middleName =
          '* Middle name can be alphabets only';
      }
      if (
        values?.customerDetails?.middleName &&
        values?.customerDetails?.middleName?.length >
          middleNameValue?.value
      ) {
        errors.customerDetails.middleName = `* Middle Name cannot be greater than ${middleNameValue?.value} characters`;
      }
      // if (!values?.customerDetails?.lastName) {
      //   errors.customerDetails.lastName = '* Required';
      // }
      if (
        values?.customerDetails?.lastName &&
        !values?.customerDetails?.lastName.match(/^[a-zA-Z. ]*$/)
      ) {
        errors.customerDetails.lastName =
          '* Last name can be alphabets only';
      }
      if (
        values?.customerDetails?.lastName &&
        values?.customerDetails?.lastName?.length >
          lastNameValue?.value
      ) {
        errors.customerDetails.lastName = `* Last Name cannot be greater than ${lastNameValue?.value} characters`;
      }
    }
    if (
      values?.customerDetails?.customerType?.code &&
      PRD_CustomerTypeList?.find(
        (type) =>
          type?.code?.toString()?.toLowerCase() ===
          values?.customerDetails?.customerType?.code
            ?.toString()
            ?.toLowerCase(),
      )
        ?.value?.toString()
        ?.toLowerCase() === 'housing society'
    ) {
      if (!values?.customerDetails?.orgInsuredName) {
        errors.customerDetails.orgInsuredName = '* Required';
      }
      // if (
      //   values?.customerDetails?.orgInsuredName &&
      //   !values?.customerDetails?.orgInsuredName.match(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+$/)
      // ) {
      //   errors.customerDetails.orgInsuredName =
      //     '* Insurer name can be alphabets only';
      // }
      if (
        values?.customerDetails?.orgInsuredName &&
        values?.customerDetails?.orgInsuredName?.length >
          orgNameValue?.value
      ) {
        errors.customerDetails.orgInsuredName = `* Insured Name cannot be greater than ${orgNameValue?.value} characters`;
      }
      if (
        values?.customerDetails?.orgInsuredName &&
        values?.customerDetails?.orgInsuredName?.length === 1
      ) {
        errors.customerDetails.orgInsuredName = `* Insured Name cannot be a single character`;
      }
    }
    // if (!values?.customerDetails?.businessOfInsured) {
    //   errors.customerDetails.businessOfInsured = '* Required';
    // }
    // if (
    //   values?.customerDetails?.businessOfInsured &&
    //   values?.customerDetails?.businessOfInsured?.length === 1
    // ) {
    //   errors.customerDetails.businessOfInsured =
    //     '* Business of Insured cannot be a single character';
    // }
    // if (
    //   values?.customerDetails?.businessOfInsured &&
    //   !values?.customerDetails?.businessOfInsured.match(
    //     /^[a-zA-Z ]*$/,
    //   )
    // ) {
    //   errors.customerDetails.businessOfInsured =
    //     '* Business of Insured can be alphabets only';
    // }
    // if (
    //   values?.customerDetails?.businessOfInsured &&
    //   !isNaN(parseInt(PRD_BusinessSumInsured?.value)) &&
    //   values?.customerDetails?.businessOfInsured?.length >
    //     parseInt(PRD_BusinessSumInsured?.value)
    // ) {
    //   errors.customerDetails.businessOfInsured = `* Business of Insured cannot be more than ${PRD_BusinessSumInsured?.value} characters`;
    // }
    if (!values?.policyTypeDetails?.geographicalArea) {
      errors.policyTypeDetails.geographicalArea = `required`
    }
    // if (
    //   values?.previousClaimExperienceDetails?.isClaimMadeInPreviousYears
    //     ?.toString()
    //     ?.toLowerCase() === 'yes'
    // ){
    //   errors.previousClaimExperienceDetails.isClaimMadeInPreviousYears="Kindly proceed this case offline as there is claim history";
    // }
    // if (
    //   values?.previousClaimExperienceDetails?.isClaimMadeInPreviousYears
    //     ?.toString()
    //     ?.toLowerCase() === 'yes'
    // ) {
    //   if (
    //     !values?.previousClaimExperienceDetails
    //       ?.claimInPreviousYearsInfo
    //   ) {
    //     errors.previousClaimExperienceDetails.claimInPreviousYearsInfo =
    //       '* Required';
    //   }
    //   if (
    //     !isNaN(parseInt(PRD_claimsInPreviousYear?.value)) &&
    //     values?.previousClaimExperienceDetails
    //       ?.claimInPreviousYearsInfo &&
    //     values?.previousClaimExperienceDetails
    //       ?.claimInPreviousYearsInfo?.length >
    //       parseInt(PRD_claimsInPreviousYear?.value)
    //   ) {
    //     errors.previousClaimExperienceDetails.claimInPreviousYearsInfo = `* Previous Claim Experience cannot be greater than ${PRD_claimsInPreviousYear?.value} characters`;
    //   }
    // }
    if (!values?.policyTypeDetails?.policyStartDate) {
      errors.policyTypeDetails.policyStartDate = '* Required';
    }
    if (
      values?.policyTypeDetails?.policyStartDate &&
      moment(
        values?.policyTypeDetails?.policyStartDate,
        'DD/MM/YYYY',
      )?.isBefore(moment(dayRange?.minDay, 'DD/MM/YYYY'))
    ) {
      errors.policyTypeDetails.policyStartDate = `* Policy start date can't be less than ${dayRange?.minDay}`;
    }
    if (
      values?.policyTypeDetails?.policyStartDate &&
      moment(
        values?.policyTypeDetails?.policyStartDate,
        'DD/MM/YYYY',
      )?.isAfter(moment(dayRange?.maxDay, 'DD/MM/YYYY'))
    ) {
      errors.policyTypeDetails.policyStartDate = `* Policy start date can't be greater than ${dayRange?.maxDay}`;
    }
    if (
      Object.keys(errors.customerDetails).length === 0 &&
      Object.keys(errors.previousClaimExperienceDetails).length ===
        0 &&
      Object.keys(errors.policyTypeDetails).length === 0 &&
      Object.keys(errors.riskLocations.addressDetails).length === 0
    ) {
      errors = {};
    }
    return errors;
  };

  const getSaveQuoteVariables = (values) => {
    return {
      input: {
        eqZone:fireQuote?.eqZone,
        locationCode:fireQuote?.locationCode,
        pinCodeLocality:fireQuote?.pinCodeLocality,
        city:fireQuote?.city,
        district:values?.district 
        ? values?.district
        : values?.riskLocations?.addressDetails?.district,
        pincode: values?.pincode
        ? values?.pincode
        :values?.riskLocations?.addressDetails?.pincode,
        state:values?.state
        ? values?.state
        : values?.riskLocations?.addressDetails?.state,
        customerDetails:
          {
            customerType:{
            code : values?.customerDetails?.customerType?.code,
            value : values?.customerDetails?.customerType?.value
            },
            orgInsuredName : values?.customerDetails?.orgInsuredName,
            firstName : values?.customerDetails?.firstName,
            middleName : values?.customerDetails?.middleName,
            lastName: values?.customerDetails?.lastName,
          },
        quoteNumber: fireQuote?.quoteNumber
          ? fireQuote?.quoteNumber
          : '',
        intermediary: {
          intermediaryCode: fireQuote?.intermediaryDetails?.code ?
            fireQuote?.intermediaryDetails?.code
            :
            selectedIntermediary?.intermediaryCode
            ? `${selectedIntermediary?.intermediaryCode}`
            : '',
          locationCode: selectedIntermediary?.branchOfficeCode
            ? `${selectedIntermediary?.branchOfficeCode}`
            : '',
          fieldUserCode: selectedIntermediary?.fieldUserCode
            ? `${selectedIntermediary?.fieldUserCode}`
            : '',
        },
        lob: lobCode,
        product: productCode,
        productName: values?.productKg,
        productKg: values?.productKg,
        customer: {
          customerType: values?.customerDetails?.customerType?.code
            ? `${values?.customerDetails?.customerType?.code}`
            : '',
          firstName:
            getDomainData(
              PRD_CustomerTypeList,
              values?.customerDetails?.customerType?.code,
              'code',
              'value',
            )
              ?.toString()
              ?.toLowerCase() === 'dwelling'
              ? values?.customerDetails?.firstName
              : '',
          middleName:
            getDomainData(
              PRD_CustomerTypeList,
              values?.customerDetails?.customerType?.code,
              'code',
              'value',
            )
              ?.toString()
              ?.toLowerCase() === 'dwelling'
              ? values?.customerDetails?.middleName
              : '',
          lastName:
            getDomainData(
              PRD_CustomerTypeList,
              values?.customerDetails?.customerType?.code,
              'code',
              'value',
            )
              ?.toString()
              ?.toLowerCase() === 'dwelling'
              ? values?.customerDetails?.lastName
              : '',
          fullName:
            getDomainData(
              PRD_CustomerTypeList,
              values?.customerDetails?.customerType?.code,
              'code',
              'value',
            )
              ?.toString()
              ?.toLowerCase() === 'dwelling'
              ? [
                  values?.customerDetails?.firstName,
                  values?.customerDetails?.middleName,
                  values?.customerDetails?.lastName,
                ]
                  ?.filter((d) => d)
                  ?.join(' ')
              : '',
          orgName:
            getDomainData(
              PRD_CustomerTypeList,
              values?.customerDetails?.customerType?.code,
              'code',
              'value',
            )
              ?.toString()
              ?.toLowerCase() === 'housing society'
              ? values?.customerDetails?.orgInsuredName
              : '',
        },
        businessOfInsured: values?.customerDetails?.businessOfInsured,
        anyPrevClaimsExp:
          values?.previousClaimExperienceDetails?.isClaimMadeInPreviousYears
            ?.toString()
            ?.toLowerCase() === 'yes'
            ? true
            : false,
        // prevClaimExpDesc:
        //   values?.previousClaimExperienceDetails
        //     ?.claimInPreviousYearsInfo,
        // isKutchaConstruct:
        //   values?.policyTypeDetails?.isInsuranceForKutchaConstruction
        //     ?.toString()
        //     ?.toLowerCase() === 'yes'
        //     ? true
        //     : false,
        policyType:
          values?.policyTypeDetails?.policyOrCoverType?.code,
        tenure: values?.policyTypeDetails?.tenure?.code,
        policyStartDate: values?.policyTypeDetails?.policyStartDate,
        geographicalArea:values?.policyTypeDetails?.geographicalArea.code,
        stageIndex: 0,
        basisOfValuation: values?.basisOfValuation,
      },
    };
  };

  const onSubmit = async (values) => {
    if(fireQuote?.status?.toString()?.toLowerCase() !=='pending uw approval'){
      if (!isQuoteReadOnly) {
        try {
          /* SA Divya - coverFetchQuery : check whether IMD mapped to any business Limit Policy
             If throw NODATAFOUND error ,then display Proper Warnig Msg and doesn't allow to proceed. */
             try{
              const coverFetchQuery =  fetchQuery({
                query: COVER_FIRESA,
                variables: {
                  input:{
                    productCode:'1132',
                    intermediaryCode: fireQuote?.intermediaryDetails?.code
                          ? fireQuote?.intermediaryDetails?.code 
                          : dataintermediary?.selectedIntermediary?.intermediaryCode
                          ? dataintermediary?.selectedIntermediary?.intermediaryCode 
                          : "",
                  subProductName: values?.productKg,//"Kotak Bharat Griha Raksha",//drop //
                  riskType: values?.customerDetails?.customerType?.value,//'Dwelling', 
                  coverType: values?.policyTypeDetails?.policyOrCoverType?.value, //'Home Contents' 
                  eqZone: fireQuote?.eqZone,
                  typeOfCover: values?.policyTypeDetails.policyOrCoverType.value, //policyTypeDetails.policyOrCoverType.value
                  basisOfValuation: values?.basisOfValuation
                  }
                }
              });
              const { data: coverData} = await coverFetchQuery;
          }catch(error){
            setParentLoading(false);
            setCustomLoadingMessage(null);
            setProceedToRiskLocationPage(false);
            if (error?.message?.toLowerCase()?.includes("no data found")) {
              error.message = `Intermediary is not mapped with any Business Limit Policy`
              setParentAlerts([
                {
                  header: 'Unable to proceed',
                  id: Date.now(),
                  content: (
                    <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                      <span>{error?.message}</span>
                    </div>
                  ),
                  type: 'warning',
                  timeout: null,
                  disableClose: false,
                },
              ]);
            }
            else if (error?.message?.toLowerCase()?.includes("not allowed")) {
              error.message = `Agreed Value is not allowed in Basis of Valuation as it is not configured in IMD level master`
              setParentAlerts([
                {
                  header: 'Unable to proceed',
                  id: Date.now(),
                  content: (
                    <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                      <span>{error?.message}</span>
                    </div>
                  ),
                  type: 'warning',
                  timeout: null,
                  disableClose: false,
                },
              ]);
            }
            else {
              setParentAlerts([
                {
                  header: 'Unable to proceed',
                  id: Date.now(),
                  content: (
                    <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                      <span>{error?.message}</span>
                    </div>
                  ),
                  type: 'Error',
                  timeout: null,
                  disableClose: false,
                },
              ]);
            }
            
            return false;
          }
          /* EA Divya - coverFetchQuery*/
          if (
            values?.previousClaimExperienceDetails?.isClaimMadeInPreviousYears
              ?.toString()
              ?.toLowerCase() === 'yes'
          ){ 
            throw new Error(
              'Kindly proceed this case offline as there is claim history since there is a claim in past 3 years',
            );
          }
          setParentAlerts([]);
          const saveQuoteInitialQuery = mutateQuery({
            mutation: SAVE_QUOTE_FIRE,
            variables: getSaveQuoteVariables(values),
          });
          setParentLoading(true);
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setCustomLoadingMessage(
            fireQuote?.quoteNumber ? 'Updating Quote' : 'Saving Quote',
          );
          const { data: saveQuoteData } = await saveQuoteInitialQuery;
          setParentLoading(false);
          setCustomLoadingMessage(null);
          setProceedToRiskLocationPage(true);
          if (
            fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value
              ?.toString()
              ?.toLowerCase() === 'floater' &&
            values?.policyTypeDetails?.policyOrCoverType?.value
              ?.toString()
              ?.toLowerCase() === 'non floater'
          ) {
            renderExpandedCardsFloater.current = {
              locationCard: true,
              floaterLocationCards: [false],
            };
          } else if (
            fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value
              ?.toString()
              ?.toLowerCase() === 'non floater' &&
            values?.policyTypeDetails?.policyOrCoverType?.value
              ?.toString()
              ?.toLowerCase() === 'floater'
          ) {
            renderExpandedCards.current = [
              {
                locationCard: true,
                stockLocationCards: [false],
              },
            ];
          }
          if (!fireQuote?.quoteNumber) {
            setParentAlerts([
              {
                header: 'Quote Save Success',
                id: Date.now(),
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      <Text severity={'success'}>
                        <FontAwesomeIcon icon={faCheck} />{' '}
                      </Text>
                      Quotation Number:{' '}
                      {saveQuoteData?.saveQuoteFireSA?.quoteNumber}
                    </Text>
                  </div>
                ),
                type: 'success',
                timeout: 3000,
                disableClose: false,
              },
            ]);
          } else {
            setParentAlerts([
              {
                id: Date.now(),
                content: (
                  <Text className="flex flex-col w-full h-full">
                    <Text type="normal">
                      Quote details updated successfully
                    </Text>
                  </Text>
                ),
                type: 'info',
                timeout: 3000,
                disableClose: false,
              },
            ]);
          }
          updateFireQuote({
            district:values?.riskLocations?.addressDetails?.district,
            pincode:values?.riskLocations?.addressDetails?.pincode,
            state:values?.riskLocations?.addressDetails?.state,
            basisOfValuation: values?.basisOfValuation,
            productKg: values?.productKg,
            productName: values?.productKg,
            customerDetails:
            {
              customerType:{
              code : values?.customerDetails?.customerType?.code,
              value : values?.customerDetails?.customerType?.value
              },
              orgInsuredName : values?.customerDetails?.orgInsuredName,
              firstName : values?.customerDetails?.firstName,
              middleName : values?.customerDetails?.middleName,
              lastName: values?.customerDetails?.lastName,
              productKg: values?.productKg,
            },
            quoteNumber: saveQuoteData?.saveQuoteFireSA?.quoteNumber
              ? `${saveQuoteData?.saveQuoteFireSA?.quoteNumber}`
              : '',
            quoteCreationDate: saveQuoteData?.saveQuoteFireSA
              ?.quoteCreationDate
              ? `${saveQuoteData?.saveQuoteFireSA?.quoteCreationDate}`
              : '',
            status:
              fireQuote?.status?.toString()?.toLowerCase() ===
              'pending uw approval'
                ? fireQuote?.status
                : saveQuoteData?.saveQuoteFireSA?.status
              ? `${saveQuoteData?.saveQuoteFireSA?.status}`
              : '',
            currentTab: 0,
            finalisedPremium: {
              locationNetPremium: '',
              locationGST: '',
              locationTotalPremium: '',
              stampDuty: '',
            },
            tabDetails: {
              ...fireQuote?.tabDetails,
              riskLocationTabDetails: {
                addOnCovers: fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers : {},
                nonFloaterType:
                  fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value
                    ?.toString()
                    ?.toLowerCase() === 'non floater' 
                    ? init_state_quote?.tabDetails
                        ?.riskLocationTabDetails?.nonFloaterType
                    : fireQuote?.tabDetails?.riskLocationTabDetails
                        ?.nonFloaterType,
                        nonFloaterType: values?.riskLocations,
              },
              customerTabDetails: {
                customerDetails: {
                  ...fireQuote?.tabDetails?.customerTabDetails
                    ?.customerDetails,
                  customerType: {
                    code: values?.customerDetails?.customerType?.code
                      ? `${values?.customerDetails?.customerType?.code}`
                      : '',
                    value: values?.customerDetails?.customerType?.value
                      ? `${values?.customerDetails?.customerType?.value}`
                      : '',
                  },
                  firstName:
                    getDomainData(
                      PRD_CustomerTypeList,
                      values?.customerDetails?.customerType?.code,
                      'code',
                      'value',
                    )
                      ?.toString()
                      ?.toLowerCase() === 'dwelling'
                      ? values?.customerDetails?.firstName
                      : '',
                  middleName:
                    getDomainData(
                      PRD_CustomerTypeList,
                      values?.customerDetails?.customerType?.code,
                      'code',
                      'value',
                    )
                      ?.toString()
                      ?.toLowerCase() === 'dwelling'
                      ? values?.customerDetails?.middleName
                      : '',
                  lastName:
                    getDomainData(
                      PRD_CustomerTypeList,
                      values?.customerDetails?.customerType?.code,
                      'code',
                      'value',
                    )
                      ?.toString()
                      ?.toLowerCase() === 'dwelling'
                      ? values?.customerDetails?.lastName
                      : '',
                  businessOfInsured:
                    values?.customerDetails?.businessOfInsured,
                  orgInsuredName:
                    getDomainData(
                      PRD_CustomerTypeList,
                      values?.customerDetails?.customerType?.code,
                      'code',
                      'value',
                    )
                      ?.toString()
                      ?.toLowerCase() === 'housing society'
                      ? values?.customerDetails?.orgInsuredName
                      : '',
                },
                // previousClaimExperienceDetails: {
                //   isClaimMadeInPreviousYears:
                //     values?.previousClaimExperienceDetails
                //       ?.isClaimMadeInPreviousYears,
                //   claimInPreviousYearsInfo:
                //     values?.previousClaimExperienceDetails?.isClaimMadeInPreviousYears
                //       ?.toString()
                //       ?.toLowerCase() === 'no'
                //       ? ''
                //       : values?.previousClaimExperienceDetails
                //           ?.claimInPreviousYearsInfo,
                // },
                policyTypeDetails: {
                  // isInsuranceForKutchaConstruction:
                  //   values?.policyTypeDetails
                  //     ?.isInsuranceForKutchaConstruction,
                  policyOrCoverType: {
                    code: values?.policyTypeDetails?.policyOrCoverType
                      ?.code,
                    value:
                      values?.policyTypeDetails?.policyOrCoverType
                        ?.value,
                  },
                  tenure: {
                    code: values?.policyTypeDetails?.tenure?.code,
                    value: values?.policyTypeDetails?.tenure?.value,
                  },
                  geographicalArea: {
                    code: values?.policyTypeDetails?.geographicalArea?.code,
                    value: values?.riskLocations.addressDetails.district,
                  },
                  policyStartDate:
                    values?.policyTypeDetails?.policyStartDate,
                  policyExpiryDate:
                    values?.policyTypeDetails?.policyExpiryDate,
                },
              },
            },
          });
          return true;
        } catch (error) {
          setParentLoading(false);
          setCustomLoadingMessage(null);
          setProceedToRiskLocationPage(false);
          setParentAlerts([
            {
              header: 'Error Saving Quote',
              id: Date.now(),
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  <span>{error?.message}</span>
                </div>
              ),
              type: 'error',
              timeout: null,
              disableClose: false,
            },
          ]);
           updateFireQuote({
            district:values?.riskLocations?.addressDetails?.district,
            pincode:values?.riskLocations?.addressDetails?.pincode,
            state:values?.riskLocations?.addressDetails?.state,
            basisOfValuation: values?.basisOfValuation,
            productKg: values?.productKg,
            customerDetails:
            {
              customerType:{
              code : values?.customerDetails?.customerType?.code,
              value : values?.customerDetails?.customerType?.value
              },
              orgInsuredName : values?.customerDetails?.orgInsuredName,
              firstName : values?.customerDetails?.firstName,
              middleName : values?.customerDetails?.middleName,
              lastName: values?.customerDetails?.lastName,
              productKg: values?.productKg,
            },
            currentTab: 0,
            tabDetails: {
              ...fireQuote?.tabDetails,
             
              customerTabDetails: {
              
                customerDetails: {
                  ...fireQuote?.tabDetails?.customerTabDetails
                    ?.customerDetails,
                  customerType: {
                    code: values?.customerDetails?.customerType?.code
                      ? `${values?.customerDetails?.customerType?.code}`
                      : '',
                    value: values?.customerDetails?.customerType?.value
                      ? `${values?.customerDetails?.customerType?.value}`
                      : '',
                  },
                  firstName:
                    getDomainData(
                      PRD_CustomerTypeList,
                      values?.customerDetails?.customerType?.code,
                      'code',
                      'value',
                    )
                      ?.toString()
                      ?.toLowerCase() === 'dwelling'
                      ? values?.customerDetails?.firstName
                      : '',
                  middleName:
                    getDomainData(
                      PRD_CustomerTypeList,
                      values?.customerDetails?.customerType?.code,
                      'code',
                      'value',
                    )
                      ?.toString()
                      ?.toLowerCase() === 'dwelling'
                      ? values?.customerDetails?.middleName
                      : '',
                  lastName:
                    getDomainData(
                      PRD_CustomerTypeList,
                      values?.customerDetails?.customerType?.code,
                      'code',
                      'value',
                    )
                      ?.toString()
                      ?.toLowerCase() === 'dwelling'
                      ? values?.customerDetails?.lastName
                      : '',
                  businessOfInsured:
                    values?.customerDetails?.businessOfInsured,
                  orgInsuredName:
                    getDomainData(
                      PRD_CustomerTypeList,
                      values?.customerDetails?.customerType?.code,
                      'code',
                      'value',
                    )
                      ?.toString()
                      ?.toLowerCase() === 'housing society'
                      ? values?.customerDetails?.orgInsuredName
                      : '',
                },
                // previousClaimExperienceDetails: {
                //   isClaimMadeInPreviousYears:
                //     values?.previousClaimExperienceDetails
                //       ?.isClaimMadeInPreviousYears,
                //   claimInPreviousYearsInfo:
                //     values?.previousClaimExperienceDetails?.isClaimMadeInPreviousYears
                //       ?.toString()
                //       ?.toLowerCase() === 'no'
                //       ? ''
                //       : values?.previousClaimExperienceDetails
                //           ?.claimInPreviousYearsInfo,
                // },
                policyTypeDetails: {
                  // isInsuranceForKutchaConstruction:
                  //   values?.policyTypeDetails
                  //     ?.isInsuranceForKutchaConstruction,
                  policyOrCoverType: {
                    code: values?.policyTypeDetails?.policyOrCoverType
                      ?.code,
                    value:
                      values?.policyTypeDetails?.policyOrCoverType
                        ?.value,
                  },
                  tenure: {
                    code: values?.policyTypeDetails?.tenure?.code,
                    value: values?.policyTypeDetails?.tenure?.value,
                  },
                  geographicalArea: {
                    code: values?.policyTypeDetails?.geographicalArea?.code,
                    value: values?.policyTypeDetails?.geographicalArea?.value,
                  },
                  policyStartDate:
                    values?.policyTypeDetails?.policyStartDate,
                  policyExpiryDate:
                    values?.policyTypeDetails?.policyExpiryDate,
                },
              },
            },
          });
          return false;
        }
      }
    }
    return true;
  };

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find((d) => d[`${searchType}`] === searchText)
      ? domainArr.find((d) => d[`${searchType}`] === searchText)[
          `${returnType}`
        ]
      : '';
  };

  const CustomerDetailsForm = ({ validate }) => {
    const { values, setFieldValue, submitForm } =
      useQuantaFormikContext();

    const data = [
      {
        title: 'Customer',
        grid_data: [
          {
            type: 'render',
            colSpan: repeat,
            component: () => (
              <CustomerDetails
                productCode={productCode}
                productName={productName}
                lobCode={lobCode}
                lobName={lobName}
                quoteNumber={quoteNumber}
                setFieldValue={setFieldValue}
                branding={branding}
                PRD_CustomerTypeList={PRD_CustomerTypeList}
                fireQuote={fireQuote}
                role={role}
              />
            ),
          },
        ],
      },
      {
        title: 'Previous Claim Experience',
        grid_data: [
          {
            type: 'render',
            colSpan: repeat,
            component: () => (
              <PreviousClaimDetails
                productCode={productCode}
                productName={productName}
                lobCode={lobCode}
                lobName={lobName}
                quoteNumber={quoteNumber}
                setFieldValue={setFieldValue}
                branding={branding}
                fireQuote={fireQuote}
                minDay={dayRange?.minDay}
                role={role}
              />
            ),
          },
        ],
      },
      {
        title: 'Policy Type',
        grid_data: [
          {
            type: 'render',
            colSpan: repeat,
            component: () => (
              <PolicyDetails
                branding={branding}
                PRD_policyPeriod={PRD_policyPeriod}
                PRD_geographicalArea = {PRD_geographicalArea}
                PRD_costOfConstruction = {''}
                PRD_typeOfPolicy={PRD_typeOfPolicy}
                PRD_basisOfValuation={PRD_basisOfValuation}
                {...{
                  lobCode,
                  productCode: productCode,
                  productName,
                  lobName,
                  quoteNumber,
                  fireQuote,
                  minDay: dayRange?.minDay,
                }}
              />
            ),
          },
        ].filter((d) => d),
      },
    ].filter((d) => d);

    const other_props = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
    };
    return (
      <div>
        <QuantaForm className="space-y-4">
          <MixedGridGroup {...{ data, ...other_props }} />
        </QuantaForm>
      </div>
    );
  };

  const initialValues = {
    district:fireQuote?.district 
    ? fireQuote?.district 
    : '',
    pincode:fireQuote?.pincode
    ? fireQuote?.pincode
    : '' ,
    state:fireQuote?.state
    ? fireQuote?.state
    : '' ,
    riskLocations:{
      addressDetails:{
        district:fireQuote?.district 
        ? fireQuote?.district 
        : '',
        pincode:fireQuote?.pincode
        ? fireQuote?.pincode
        : '' ,
        state:fireQuote?.state
        ? fireQuote?.state
        : '' ,
      }
    },
    customerDetails: {
      customerType: {
        code: fireQuote?.customerDetails?.customerType?.code
          ? fireQuote?.customerDetails
              ?.customerType?.code
          : PRD_CustomerTypeList?.find(
              (type) =>
                type?.value?.toString()?.toLowerCase() ===
                'dwelling',
            )?.code
          ? PRD_CustomerTypeList?.find(
              (type) =>
                type?.value?.toString()?.toLowerCase() ===
                'dwelling',
            )?.code
          : '',
        value: fireQuote?.customerDetails?.customerType?.value
          ? fireQuote?.customerDetails
              ?.customerType?.value
          : PRD_CustomerTypeList?.find(
              (type) =>
                type?.value?.toString()?.toLowerCase() ===
                'dwelling',
            )?.value
          ? PRD_CustomerTypeList?.find(
              (type) =>
                type?.value?.toString()?.toLowerCase() ===
                'dwelling',
            )?.value
          : '',
      },
      firstName: fireQuote?.customerDetails?.firstName
        ? fireQuote?.customerDetails?.firstName
        : '',
      middleName: fireQuote?.customerDetails?.middleName
        ? fireQuote?.customerDetails
            ?.middleName
        : '',
      lastName: fireQuote?.customerDetails?.lastName
        ? fireQuote?.customerDetails
            ?.lastName
        : '',
      businessOfInsured: fireQuote?.tabDetails?.customerTabDetails
        ?.customerDetails?.businessOfInsured
        ? fireQuote?.tabDetails?.customerTabDetails?.customerDetails
            ?.businessOfInsured
        : '',
      orgInsuredName: fireQuote?.customerDetails?.orgInsuredName
        ? fireQuote?.customerDetails
            ?.orgInsuredName
        : '',
      productKg: fireQuote?.productKg ? fireQuote?.productKg : 'Kotak Bharat Griha Raksha',
    },
    previousClaimExperienceDetails: {
      isClaimMadeInPreviousYears: fireQuote?.tabDetails
        ?.customerTabDetails?.previousClaimExperienceDetails
        ?.isClaimMadeInPreviousYears
        ? fireQuote?.tabDetails?.customerTabDetails
            ?.previousClaimExperienceDetails
            ?.isClaimMadeInPreviousYears
        : 'No',
      claimInPreviousYearsInfo: fireQuote?.tabDetails
        ?.customerTabDetails?.previousClaimExperienceDetails
        ?.claimInPreviousYearsInfo
        ? fireQuote?.tabDetails?.customerTabDetails
            ?.previousClaimExperienceDetails?.claimInPreviousYearsInfo
        : '',
    },
    policyTypeDetails: {
      // isInsuranceForKutchaConstruction: fireQuote?.tabDetails
      //   ?.customerTabDetails?.policyTypeDetails
      //   ?.isInsuranceForKutchaConstruction
      //   ? fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails
      //       ?.isInsuranceForKutchaConstruction
      //   : 'No',
      policyOrCoverType: {
        code: fireQuote?.tabDetails?.customerTabDetails
          ?.policyTypeDetails?.policyOrCoverType?.code
          ? fireQuote?.tabDetails?.customerTabDetails
              ?.policyTypeDetails?.policyOrCoverType?.code
          : PRD_typeOfPolicy && PRD_typeOfPolicy?.length > 0
          ? PRD_typeOfPolicy[0]?.code
          : '',
        value: fireQuote?.tabDetails?.customerTabDetails
          ?.policyTypeDetails?.policyOrCoverType?.value
          ? fireQuote?.tabDetails?.customerTabDetails
              ?.policyTypeDetails?.policyOrCoverType?.value
          : PRD_typeOfPolicy && PRD_typeOfPolicy?.length > 0
          ? PRD_typeOfPolicy[0]?.value
          : '',
      },
      tenure: {
        code: fireQuote?.tabDetails?.customerTabDetails
          ?.policyTypeDetails?.tenure?.code
          ? fireQuote?.tabDetails?.customerTabDetails
              ?.policyTypeDetails?.tenure?.code
          : PRD_policyPeriod && PRD_policyPeriod?.length > 0
          ? PRD_policyPeriod[0]?.code
          : '',
        value: fireQuote?.tabDetails?.customerTabDetails
          ?.policyTypeDetails?.tenure?.value
          ? fireQuote?.tabDetails?.customerTabDetails
              ?.policyTypeDetails?.tenure?.value
          : PRD_policyPeriod && PRD_policyPeriod?.length > 0
          ? PRD_policyPeriod[0]?.value
          : '',
      },
      
      geographicalArea: {
        code: fireQuote?.tabDetails?.customerTabDetails
          ?.policyTypeDetails?.geographicalArea?.code
          ? fireQuote?.tabDetails?.customerTabDetails
              ?.policyTypeDetails?.geographicalArea?.code
          : PRD_geographicalArea && PRD_geographicalArea?.length > 0
          ? PRD_geographicalArea[0]?.code
          : '',
        value: fireQuote?.tabDetails?.customerTabDetails
          ?.policyTypeDetails?.geographicalArea?.value
          ? fireQuote?.tabDetails?.customerTabDetails
              ?.policyTypeDetails?.geographicalArea?.value
          : PRD_geographicalArea && PRD_geographicalArea?.length > 0
          ?PRD_geographicalArea[0]?.value
          : '',
      },
      policyStartDate: fireQuote?.tabDetails?.customerTabDetails
        ?.policyTypeDetails?.policyStartDate
        ? fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails
            ?.policyStartDate
        : dayRange?.minDay,
      policyExpiryDate: fireQuote?.tabDetails?.customerTabDetails
        ?.policyTypeDetails?.policyExpiryDate
        ? fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails
            ?.policyExpiryDate
        : '',
    },
    basisOfValuation: fireQuote?.basisOfValuation
      ? fireQuote?.basisOfValuation
      : 'Reinstatement value',
    productKg: fireQuote?.productKg ? fireQuote?.productKg : 'Kotak Bharat Griha Raksha',
  };

  return (
    <div>
      {!initialValues && (
        <div className="min-h-screen">
          <Loading />
        </div>
      )}
      {initialValues && (
        <QuantaFormik
          innerRef={props?.customerDetailsFormRef}
          enableReinitialize={true}
          {...{
            initialValues,
            validate,
            onSubmit,
          }}
        >
          <CustomerDetailsForm {...{ validate }} />
        </QuantaFormik>
      )}
    </div>
  );
}
